/**
 * Prevent Blade Forms From Submitting Twice
 */
function singleClickSubmit() {
  const submitButton = document.getElementById('single_click_submit')

  if (submitButton) {
    let processing = false

    submitButton.addEventListener('click', function (e: MouseEvent) {
      e.preventDefault()

      if (!processing) {
        processing = true
        submitButton.disabled = true

        // slight delay on submit to let any UI settle
        setTimeout(() => {
          this.form.submit()
        }, 100)
      }
    })
  }
}

export default singleClickSubmit
